import React from "react";
import CircularProgress from '@mui/material/CircularProgress';

export default function ButtonLoader() {

    return (
        <CircularProgress size={24} />
    )
};